export default __webpack_public_path__ + "static/media/zelle_white.71e84522.svg";